import { Directive, Input, ElementRef, AfterViewInit, Renderer2, OnInit } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[whatIsThisTooltip]'
})
export class WhatisthisTooltipDirective implements OnInit {

  @Input()
  whatIsThisTooltip : string ;

  
  
  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef) { }


  ngOnInit(): void {

    // placement="top" ngbTooltip="Tooltip on top" ngbTooltipClass="kt-tooltip"
    this.renderer.setAttribute(this.elementRef.nativeElement, 'placement','top');
    this.renderer.setAttribute(this.elementRef.nativeElement, 'ngbTooltip','Tooltip on top');  
    this.renderer.setAttribute(this.elementRef.nativeElement, 'ngbTooltipClass','kt-tooltip');  
  }


}
